import './index.scss'

import VueMask from 'v-mask'
import Vue from 'vue'

import FromQr from './views/FromQr.vue'
import createVuetify from './vuetify'
import components from './vuetify-components-qr_code_visit'

Vue.use(VueMask)

new Vue({
  el: '#app',
  vuetify: createVuetify(components),
  render: h => h(FromQr)
})
